import React from 'react'
import { string, func } from 'prop-types'

import { MenuItem } from '@cgtrader/triangle-ui/dist/src/ssr-index'

function Keyword({
  searchKeyword,
  suggestedKeyword,
  thumbnailUrl = '',
  onKeywordClick,
}) {
  const lowerCasedQuery = searchKeyword.toLowerCase()

  const renderLetter = (char, index) => {
    const isBolded = lowerCasedQuery.includes(char.toLowerCase())
    return isBolded ? (
      char
    ) : (
      <b key={`${suggestedKeyword}-letter-${index}`}>{char}</b>
    )
  }

  const label = (
    <div className="new-search__suggestion-wrapper">
      {thumbnailUrl && (
        <img
          src={thumbnailUrl}
          alt=""
          className="new-search__suggestion-thumbnail"
        />
      )}
      <span>
        {[...suggestedKeyword].map((letter, index) => renderLetter(letter, index))}
      </span>
    </div>
  )

  const onClick = () => onKeywordClick({ suggestedKeyword })

  return (
    <li
      className="new-search__suggestion"
      data-track="search-suggestion-click"
      data-suggestion-type="keyword"
      data-selected-keyword={suggestedKeyword}
      data-content-type="search-suggestion"
    >
      <MenuItem fluid label={label} onClick={onClick} />
    </li>
  )
}

Keyword.propTypes = {
  suggestedKeyword: string.isRequired,
  searchKeyword: string.isRequired,
  onKeywordClick: func.isRequired,
  thumbnailUrl: string,
}

export default Keyword
